import { Checkbox, Grid, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from 'components/Autocomplete'
import { useCallback, useEffect, useState } from 'react'

import { SelecionarData } from 'components'
import { WrapperFiltros } from 'components/WrapperFiltros'
import { useFormState } from 'hooks/useFormState'
import { usePericiandoService } from 'hooks/usePericiandoService'
import useStyles from './styles'

export const FiltrosBancoPericiandos = (props) => {
  const { setPericiandos, setProcessandoPericiando } = props
  const classes = useStyles()
  const periciandoService = usePericiandoService()

  const formFiltroPericiando = useFormState(
    {},
    {
      alcunha: '',
      nome: '',
      classificacao: '',
      dataEntradaInicio: new Date(),
      dataEntradaFinal: new Date(),
      sexo: null,
      dataEntradaChecked: false,
    }
  )

  const filtrarPericiando = useCallback(async () => {
    const response = await periciandoService.listarPericiandosFiltradosAsync(formFiltroPericiando.formState.values, setProcessandoPericiando)
    setPericiandos(response)
  }, [formFiltroPericiando.formState.values])

  useEffect(() => {
    filtrarPericiando()
  }, [])

  useEffect(() => {
    if (!formFiltroPericiando.formState.values.dataEntradaFinal) {
      const dataAtual = new Date()
      dataAtual.setHours(0, 0, 0, 0)
      const dataDiaAnterior = new Date(dataAtual.getTime())
      dataDiaAnterior.setDate(dataAtual.getDate() - 1)
      formFiltroPericiando.setFormState((formState) => ({
        ...formState,
        values: {
          ...formState.values,
          dataEntradaInicio: dataDiaAnterior,
          dataEntradaFinal: dataAtual,
        },
      }))
    }
  }, [])

  const handleLimparFiltros = useCallback(async () => {
    formFiltroPericiando.setFormState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        alcunha: '',
        nome: '',
        classificacao: '',
        dataEntradaInicio: new Date(),
        dataEntradaFinal: new Date(),
        sexo: null,
        dataEntradaChecked: false,
      },
    }))

    const response = await periciandoService.listarPericiandosFiltradosAsync(
      {
        alcunha: '',
        nome: '',
        classificacao: '',
        dataEntradaInicio: new Date(),
        dataEntradaFinal: new Date(),
        sexo: null,
      },
      setProcessandoPericiando
    )
    setPericiandos(response)
  }, [formFiltroPericiando])

  const classificacaoOptions = ['Menor Infrator', 'Detido', 'Agente de Segurança Pública', 'Maria da Penha', 'ECA (Lei 8069/1990)', 'Estupro de Vulnerável I', 'Estupro de Vulnerável II', 'Estupro (Não vulnerável)', 'Demais Casos']

  return (
    <WrapperFiltros handleLimparFiltros={handleLimparFiltros} handleFiltrar={filtrarPericiando}>
      <Grid item md={4} sm={12} xs={12} className={classes.grupoFiltros}>
        <Typography variant="subtitle2" className={classes.grupoTitle}>
          Dados do Periciando
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} className={classes.field}>
            <TextField fullWidth label="NOME DO PERICIANDO" name="nome" onChange={formFiltroPericiando.handleChange} value={formFiltroPericiando.formState.values.nome || ''} variant="outlined" InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={12} className={classes.field}>
            <TextField fullWidth label="ALCUNHA DO PERICIANDO" name="alcunha" onChange={formFiltroPericiando.handleChange} value={formFiltroPericiando.formState.values.alcunha || ''} variant="outlined" InputLabelProps={{ shrink: true }} />
          </Grid>
        </Grid>
      </Grid>

      <Grid item md={4} sm={12} xs={12} className={classes.grupoFiltros}>
        <Typography variant="subtitle2" className={classes.grupoTitle}>
          Classificação e Sexo
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} className={classes.field}>
            <Autocomplete
              value={formFiltroPericiando.formState.values.classificacao}
              name="classificacao"
              options={classificacaoOptions}
              onChange={(event, newValue) => {
                formFiltroPericiando.handleChangeNewValueByNameProperty(event, newValue, 'classificacao')
              }}
              label="CLASSIFICAÇÃO (NATUREZA DA SOLICITAÇÃO)"
              renderOption={(option) => option}
              disableCloseOnSelect={false}
            />
          </Grid>
          <Grid item xs={12} className={classes.field}>
            <Autocomplete
              value={formFiltroPericiando.formState.values.sexo}
              name="sexo"
              options={['Masculino', 'Feminino']}
              onChange={(event, newValue) => {
                formFiltroPericiando.handleChangeNewValueByNameProperty(event, newValue, 'sexo')
              }}
              label="SEXO"
              renderOption={(option) => option}
              disableCloseOnSelect={false}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item md={4} sm={12} xs={12} className={classes.grupoFiltros}>
        <Typography variant="subtitle2" className={classes.grupoTitle}>
          Período
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} className={classes.itemData}>
            <Grid alignItems="center" container spacing={1}>
              <Grid item xs={2}>
                <Checkbox checked={formFiltroPericiando.formState.values.dataEntradaChecked || false} onChange={formFiltroPericiando.handleChange} name="dataEntradaChecked" />
              </Grid>
              <Grid item xs={5}>
                <SelecionarData
                  dataBD={formFiltroPericiando.formState.values.dataEntradaInicio}
                  withoutTime
                  callback={(valor) => formFiltroPericiando.handleChangeCampoData('dataEntradaInicio', valor)}
                  label="Entrada - Início"
                  disabled={!formFiltroPericiando.formState.values.dataEntradaChecked}
                  name="dataEntradaInicio"
                  maxDate={formFiltroPericiando.formState.values.dataEntradaFinal}
                />
              </Grid>
              <Grid item xs={5}>
                <SelecionarData
                  dataBD={formFiltroPericiando.formState.values.dataEntradaFinal}
                  withoutTime
                  callback={(valor) => formFiltroPericiando.handleChangeCampoData('dataEntradaFinal', valor)}
                  label="Entrada - Final"
                  disabled={!formFiltroPericiando.formState.values.dataEntradaChecked}
                  name="dataEntradaFinal"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </WrapperFiltros>
  )
}
